import { render, staticRenderFns } from "./HospedajesReportsTable.vue?vue&type=template&id=68ef3f64&"
import script from "./HospedajesReportsTable.vue?vue&type=script&lang=js&"
export * from "./HospedajesReportsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports